import { useMissionsTranslation } from '../../../../ui/hooks';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import { Box, Typography } from '@mui/material';
import React from 'react';
export const PendingHoursStatus = () => {
    const { t } = useMissionsTranslation();
    return (React.createElement(Box, { display: 'flex', sx: { gap: 1, alignItems: 'center', color: (theme) => theme.palette.grey[700] }, "data-test": 'pending-hours-status' },
        React.createElement(TimelapseIcon, { fontSize: 'small' }),
        React.createElement(Typography, { variant: 'subtitle2' }, t('missions.missionDetails.pendingRequest'))));
};
